import {getIsCroft} from "../../utils/croft";
import React from "react";

export default (props) => {
    const isCroft = getIsCroft();
    
    return <span>
        {isCroft ? "Croft Circuit" : "Thruxton"}
    </span>
}